import { FC } from 'react';
//components
import SidebarList from 'components/common/SidebarList';
//constants
import { ADMIN_SIDEBAR_LIST } from 'constants/index';

const AdminSidebar: FC = (): JSX.Element => <SidebarList list={ADMIN_SIDEBAR_LIST} />;

export default AdminSidebar;
